import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileAvatarAPI } from '../../../api'
import { userData } from 'features/user/store'
import {
  PROFILE_AVATAR_REMOVE_REQUEST,
  PROFILE_AVATAR_REMOVE_SUCCESS,
  PROFILE_AVATAR_REMOVE_FAILED,
} from './actionTypes'

export const profileAvatarRemovePA = createPromiseAction(
  PROFILE_AVATAR_REMOVE_REQUEST,
  PROFILE_AVATAR_REMOVE_SUCCESS,
  PROFILE_AVATAR_REMOVE_FAILED
)()

function* remove(action) {
  try {
    const response = yield call(profileAvatarAPI.deleteAvatar)
    const { data } = response

    yield put(profileAvatarRemovePA.success({}))

    yield put(userData.updateData({ avatar: null }))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* removeSaga() {
  yield takeEvery(profileAvatarRemovePA.request, remove)
}
